<template>
	<div class="columns is-vcentered">
		<div class="column py-2 is-1">
			<p class="ap-cell ap-cell--num has-text-right">{{ index + 1 }}.-</p>
		</div>
		<div class="column py-2 is-2">
			<p class="ap-cell ap-cell--strong">{{ item.level_1 }}</p>
		</div>
		<div :class="['column', 'py-2', showBalanceConcept ? 'is-2' : 'is-3']">
			<p class="ap-cell">{{ item.level_2 }}</p>
		</div>
		<div :class="['column', 'py-2', showBalanceConcept ? 'is-3' : 'is-4']">
			<p class="ap-cell">{{ item.level_3 }}</p>
		</div>
		<div v-if="showBalanceConcept" class="column py-2 is-2">
			<p class="ap-cell ap-cell--concept">{{ item.balance_concept || "—" }}</p>
		</div>
		<div class="column py-2 is-1">
			<span class="tag is-rounded is-primary">{{ item.order }}</span>
		</div>
		<!-- px-1: la columna is-1 (~67px útiles con el gutter default) no
			alcanza para los dos botones — sin esto el tacho se sale del
			borde de la fila. -->
		<div class="column py-2 px-1 is-1 ap-ops">
			<template v-if="!readonly">
				<button type="button" class="ap-icon-btn" aria-label="Editar cuenta"
					@click="$emit('edit-account')">
					<EditPencil />
				</button>
				<button type="button" class="ap-icon-btn" aria-label="Eliminar cuenta"
					@click="$emit('delete-account')">
					<Trash />
				</button>
			</template>
			<span v-else class="ap-ops__locked" title="Plan bloqueado">—</span>
		</div>
	</div>
</template>

<script>
import EditPencil from "@/components/svg/EditPencil";
import Trash from "@/components/svg/Trash";

export default {
	name: "AccountPlanRow",
	components: {
		EditPencil,
		Trash,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
		// Muestra la columna "Cuenta X" (KPIs de Balance). Opt-in para que la
		// fila siga alineada con los headers de cada vista.
		showBalanceConcept: {
			type: Boolean,
			default: false,
		},
		// Plan bloqueado (docs/decisiones §30): sin editar ni eliminar.
		readonly: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style scoped lang="scss">
.ap-cell {
	font-size: 1rem;
	color: var(--ap-ink-2);

	&--strong {
		font-weight: 600;
		color: var(--ap-ink);
	}

	&--num {
		font-weight: 600;
		font-variant-numeric: tabular-nums;
	}

	&--concept {
		font-size: 0.85rem;
		color: var(--ap-slate);
	}
}

.tag.is-primary {
	background-color: var(--ap-teal-wash);
	color: var(--ap-teal-deep);
	font-weight: 700;
	font-variant-numeric: tabular-nums;
}

// ── Operaciones (iconos) ────────────────────────────────────────────────
// Dos botones de 28px + gap = 60px: entran en la columna is-1 (con px-1)
// sin desbordar la fila ni pisarse entre sí.
.ap-ops {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.25rem;

	&__locked {
		color: var(--ap-muted);
	}
}

.ap-icon-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 28px;
	height: 28px;
	padding: 0;
	background: transparent;
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-slate);
	cursor: pointer;
	transition: color 0.18s var(--ap-ease), border-color 0.18s var(--ap-ease);

	:deep(svg) {
		width: 14px;
		height: 14px;
	}

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}
</style>
